import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import dzHome from '@/pages/dzHome'

Vue.use(Router)

const routes = [
	{
		path: '/result',
		name: 'result',
		meta: {
			auth: false,
		},
		component: () => import(/*webpackPrefetch:true */ "../pages/Result.vue"),
	},
	{
		path: '/login',
		name: 'login',
		meta: {
			auth: false,
		},
		component: () => import(/*webpackPrefetch:true */ "../pages/login.vue"),
	},
	{
		path: '/newsInfo',
		name: 'newsInfo',
		meta: {
			auth: false,
		},
		component: () => import(/*webpackPrefetch:true */ "../pages/newsInfo.vue"),
	},
	{
		path: '/applyform',
		name: 'applyform',
		meta: {
			auth: true,
			keepAlive: true // 标记需要缓存的组件
		},
		component: () => import(/*webpackPrefetch:true */ "../pages/ApplyForm.vue"),
	},

	{
		path: '/',
		name: 'dzHome',
		meta: {
			auth: false,
		},
		component: dzHome
	},
	{
		path: '/home',
		name: 'home',
		meta: {
			auth: false,
		},
		component: home
	}

]

var router = new Router({
	base: process.env.BASE_URL,
	routes
})


export default router;